import React from "react";
import { withRouter } from "react-router-dom";
import ServiceForm from "./components/serviceForm";
function addRound() {
  return <ServiceForm></ServiceForm>;
}
export default withRouter(addRound);
